export const FAVORITOS_KEY = 'favoritos'